import { cn } from "@/lib/utils";

export default function KpiCard({ label, value, sublabel, accent, testId }) {
  return (
    <div
      className="border border-zinc-200 rounded-lg bg-white p-5 hover:border-zinc-300 transition-colors"
      data-testid={testId}
    >
      <div className="text-[10px] font-semibold uppercase tracking-[0.16em] text-zinc-500">
        {label}
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <div className={cn("font-heading text-3xl font-extrabold tracking-tight text-zinc-900", accent)}>
          {value}
        </div>
        {sublabel && <div className="text-xs text-zinc-500">{sublabel}</div>}
      </div>
    </div>
  );
}
